<template>
  <div>
    <div class="header-container">
      <el-switch v-model="publicFile" active-text="Esse arquivo pode ser público" inactive-text="">
      </el-switch>
      <el-select style="max-width: 450px; margin-left: 25px;" v-model="key" multiple filterable allow-create
        default-first-option placeholder="Informe o tipo de documento" :multiple-limit="1">
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </div>
    <br />

    <el-upload class="upload-demo" :on-change="changeFile" v-loading="loading" drag action="/api/s3upload/public"
      :auto-upload="false" ref="upload" :file-list="fileList">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        Arraste o arquivo ou <em>clique para aqui para enviar</em>
      </div>
    </el-upload>


    <el-button style="margin-left: 10px;" type="success" @click="upload">Enviar arquivo</el-button>

  </div>
</template>

<script>
import { UploadService } from "@/services/customers/upload.services";

export default {
  name: "ImportDocs",
  data() {
    return {
      fileList: [],
      active: 0,
      publicFile: true,
      loading: false,
      file: undefined,
      key: undefined,
      options: [
        {
          value: 'user-terms',
          label: 'Termos de uso'
        },
      ],

    };
  },

  methods: {
    upload() {
      const vm = this;
      if (!vm.file) {
        return vm.$message({
          type: "error",
          message: 'Você deve selecionar um arquivo para realizar o upload',
        });
      }
      const privacy = vm.publicFile ? 'public' : 'private'

      let formData = new FormData();
      formData.append(`file`, vm.file.raw);
      formData.append(`privacy`, privacy)
      formData.append(`key`, vm.key[0])

      vm.loading = true;

      UploadService.uploadDocs(formData, privacy)
        .then((response) => {
          vm.$message({
            type: 'success',
            message: response.message
          })
          vm.fileList = [];
          vm.key = undefined;
          vm.publicFile = true;
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        }).finally(() => vm.loading = false);
    },

    changeFile(file) {
      const vm = this;
      vm.file = file;
    },
  },
};
</script>
<style>
.upload-demo {
  margin-top: 15px;

}

.header-container {
  display: flex;
  align-items: center;

}
</style>